/* ============================================================
   Case studies carousel — Swiper 11 (bundled per page)
   ------------------------------------------------------------
   Swiper is `import`ed from the npm ESM build, so esbuild bundles
   it straight into this page's JS — it only ships on pages whose
   entry imports this component (see case-studies.css / .case-studies-swiper).
   The ESM build is modular: register only the features we use
   (Navigation) so unused Swiper modules are tree-shaken out.
   ============================================================ */
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectFade,
  Mousewheel,
  Keyboard,
} from "swiper/modules";

export function initCaseStudiesCarousel() {
  const el = document.querySelector(".case-studies-swiper");
  if (!el) return;

  new Swiper(el, {
    modules: [Navigation, Pagination, EffectFade, Mousewheel, Keyboard],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 600,
    navigation: {
      prevEl: "[data-case-prev]",
      nextEl: "[data-case-next]",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}
